import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Textarea,
  useDisclosure,
} from '@chakra-ui/react'
import React from 'react'
import { useForm } from 'react-hook-form'
import { baseURL } from '../../../../services/api'
import { user } from '../../../../helpers/user'

const codUsuario = user.codigo_usuario

export function RecebimentoXbzAlert({ item, filtrarStatus }) {
  console.log('item', item)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    reset,
  } = useForm()
  const textAreaRef = React.useRef()

  async function handleRecebimentoXbzBip(data) {
    try {
      const response = await baseURL.post('/crm-controle/importacao-nota', {
        numero_pedido: item.numero_pedido,
        numero_nota: item.codigo_nota,
        codigo_nota: data?.bip,
      })

      await baseURL.get(`/pedido/atualiza-data-troca/${item.codigo_nota}/${item.codigo_produto}/${item.sequencia}/${codUsuario}`)

      console.log('response', response)

      filtrarStatus()

      onClose()
      reset()
      return response
    } catch (err) {
      console.error(err)
    }
  }

  function handleOpen() {
    if (!item.data_inicio_troca) {
      return alert('É necessário completar o passo Solicitação de Trocas antes de prosseguir.')
    }

    onOpen()
    setTimeout(() => textAreaRef.current.focus(), 100)
  }

  return (
    <>
      <Button size="sm" colorScheme="blue" onClick={handleOpen} mt={2}>
        Receb. Xbz
      </Button>

      <AlertDialog isOpen={isOpen} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirmar Recebimento Xbz
            </AlertDialogHeader>

            <AlertDialogBody>
              Por favor, bipe o pedido campo abaixo.
              <Textarea placeholder="Bipe o pedido" size="sm" mt={2} {...register('bip')} onFocus={() => textAreaRef.current.focus()} />
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onClose}>Cancelar</Button>
              <Button colorScheme="green" ml={3} isLoading={isSubmitting} onClick={handleSubmit(handleRecebimentoXbzBip)}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
